import Booking from "../../images/adminBooking.png";
import Customer from "images/AdminProfile.svg";
import feedback from "../../images/adminFeedback.svg";
import Contact_us from "../../images/adminContact.svg";
import Header from "components/Header";
import { Col, Row } from "reactstrap";
import PageContainer from "common/PageContainer";
import chef from "images/chef-img.svg";
import { useContext } from "react";
import { DashboardContext } from "./context";
import PageLoader from "common/PageLoader";
import { UpcomingTable } from "components/UpcomingTable";

const UserDesh = () => {
  const dashboardContext = useContext(DashboardContext);

  const isLoading = dashboardContext?.dashBoardData?.isLoading;
  const status = dashboardContext?.dashBoardData?.status;
  const error = dashboardContext?.dashBoardData?.error;
  const dashboardData = dashboardContext?.dashBoardData?.data;


     console.log(".................",dashboardData)
  
    if (isLoading) return <PageLoader />;
  if (error) {
    return <span>Something went wrong!</span>;
  }
  if (status === 200 && !dashboardData) return <span>No data found!</span>;

  return (
    <>
      <div className="me-5 mt-2">
        <Header totalCount={null} heading={'User Dashboard'} />
      </div>

      <Row className="gap-4 ms-2 me-5 mt-3">
        <Col className="border rounded d-flex total-customer">
          <img src={Customer} alt="" className="mt-3 " />

          <Col className="mt-3 ms-5">
            <h6 className="mb-0 dashboard-heading-text">Total Customers</h6>
            <span className="">{dashboardData?.users?.total}</span>
          </Col>
          <Col xs="1" className="seprator">
            |
          </Col>
          <Col className="mt-3">
            <h6 className="active-user mb-0">Active Customers</h6>
            <span className="">{dashboardData?.users?.active}</span>
          </Col>
        </Col>
        <Col className="border rounded  total-customer">
          <Col className="d-flex align-items-center">
            <div className="chef mt-3">
              <img src={chef} alt="Chef" className="chef-img" />
            </div>
            <Col className="mt-3 ms-5">
              <h6 className="mb-0 dashboard-heading-text">Total Partners</h6>
              <span>{dashboardData?.chefs?.total}</span>
            </Col>
            <Col xs="1" className="seprator">
              |
            </Col>
            <Col className="mt-3">
              <h6 className="active-user mb-0">Active Partners</h6>
              <span>{dashboardData?.chefs?.active}</span>
            </Col>
          </Col>
        </Col>
        <Col className="border rounded d-flex total-customer">
          <Col className="d-flex ">
            <div className="chef mt-3">
              <img src={chef} alt="" className="chef-img" />
            </div>
            <Col className="mt-3 ms-5">
              <h6 className="mb-0 dashboard-heading-text">Total Vendors</h6>
              <span className="">{dashboardData?.vendors?.total}</span>
            </Col>
            <Col xs="1" className="seprator">
              |
            </Col>
            <Col className="mt-3">
              <h6 className="active-user mb-0">Active Vendors</h6>
              <span className="">{dashboardData?.vendors?.active}</span>
            </Col>
          </Col>
        </Col>
      </Row>

      <Row className="gap-4 ms-2 mt-5 me-5 " xs="8">
        <Col xs="8" className="border rounded">
          <Row className="">
            <Col className="d-flex align-items-center mt-2">
              <img src={Booking} alt="Booking" className="booking-img" />
              <h6 className="ms-3 mt-2 dashboard-booking-title">Bookings</h6>
            </Col>
          </Row>

          <Row className="d-flex flex-nowrap w-70  mt-5 booking-contain">
            <Col xs="2" className="">
              <h6 className="active-user mb-0">Total Bookings</h6>
              <span>{dashboardData?.bookings?.total}</span>
            </Col>
            <Col xs="1" className="seprator  ">
              |
            </Col>
            <Col xs="2" className="">
              <h6 className="active-user mb-0">Unassigned</h6>
              <span>{dashboardData?.bookings?.unassigned}</span>
            </Col>
            <Col xs="1" className="seprator ">
              |
            </Col>
            <Col xs="3" className="">
              <h6 className="active-user mb-0">Completed Bookings</h6>
              <span>{dashboardData?.bookings?.completed}</span>
            </Col>
            <Col xs="1" className="seprator ">
              |
            </Col>
            <Col xs="2" className="">
              <h6 className="active-user mb-0">Canceled Bookings</h6>
              <span>{dashboardData?.bookings?.canceled}</span>
            </Col>
          </Row>
        </Col>

        <Col className="gap-2">
          <Row className="border rounded p-2 mb-2 feedbacks-contains">
            <Col className="d-flex">
              <img src={feedback} alt="" className="feedback-img mt-2" />
              <Col className="ms-4 mt-2">
                <h6 className="active-user mb-0 ">Feedbacks</h6>
                <span className="" style={{ color: "black" }}>
                  {dashboardData?.ratings?.total}
                </span>
              </Col>
            </Col>
          </Row>
          <Col>
            <Row className="border rounded p-2 mt-3 feedbacks-contains">
              <Col className="d-flex ">
                <img src={Contact_us} alt="" className="contactus-img mt-2" />
                <Col className=" ms-4 mt-2">
                  <h6 className="active-user mb-0">Lead's</h6>
                  <span className="" style={{ color: "black" }}>
                    {dashboardData?.leads?.total}
                  </span>
                </Col>
              </Col>
            </Row>
          </Col>
        </Col>
      </Row>

      <PageContainer>
        <UpcomingTable/>
        
      </PageContainer>
    </>
  );
};

export default UserDesh;
